import React from 'react';
import { Link } from 'react-router-dom';
import { FOOTER } from '@/constants/testIds';
import { Mail } from 'lucide-react';

export default function Footer() {
  return (
    <footer data-testid={FOOTER.root} className="relative border-t border-white/10 bg-[#000919] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Link to="/" data-testid={FOOTER.logo} className="flex items-center gap-3">
            <img src="/brand/sellrly-logotype-single.png" alt="Sellrly" className="h-10 w-auto" />
          </Link>
          <p className="mt-6 text-white/65 max-w-md leading-relaxed">
            Fully managed media for DTC brands, podcasters, creators, social sellers and subscription businesses.
            Agency-grade execution. No bureaucracy. No headcount required.
          </p>
          <Link
            to="/contact#contact-form"
            className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold text-white bg-[#FF5081] hover:bg-[#ff3a73] hover:-translate-y-px shadow-[0_8px_22px_-12px_rgba(255,80,129,0.55)] transition-all"
          >
            Book a strategy call
          </Link>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/40">Navigate</p>
          <ul className="mt-4 space-y-3 text-white/75">
            <li><Link to="/" className="hover:text-[#FF5081]">Home</Link></li>
            <li><Link to="/services" className="hover:text-[#FF5081]">Services</Link></li>
            <li><Link to="/case-studies" className="hover:text-[#FF5081]">Case Studies</Link></li>
            <li><Link to="/about" className="hover:text-[#FF5081]">About</Link></li>
            <li><Link to="/contact" className="hover:text-[#FF5081]">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/40">Contact</p>
          <a href="mailto:hello@sellrly.com" className="mt-4 flex items-center gap-2 text-white/80 hover:text-[#FF5081]">
            <Mail className="w-4 h-4" /> hello@sellrly.com
          </a>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-white/45">
          <p>© {new Date().getFullYear()} Sellrly. All rights reserved.</p>
          <p className="font-display tracking-wide">Your media, managed. Your results, owned.</p>
        </div>
      </div>
    </footer>
  );
}
